/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdditionalWorkDto } from '../models/AdditionalWorkDto';
import type { BranchType } from '../models/BranchType';
import type { CarClass } from '../models/CarClass';
import type { CreateModelPricePartDto } from '../models/CreateModelPricePartDto';
import type { CreateMotOptionBranchInput } from '../models/CreateMotOptionBranchInput';
import type { CreateMotOptionInput } from '../models/CreateMotOptionInput';
import type { CreateServicePriceGroupInput } from '../models/CreateServicePriceGroupInput';
import type { CreateServicePriceInput } from '../models/CreateServicePriceInput';
import type { EventServicesDto } from '../models/EventServicesDto';
import type { EventServicesInput } from '../models/EventServicesInput';
import type { FixedPriceRepairDto } from '../models/FixedPriceRepairDto';
import type { FixedPriceRepairViewModelPagedListData } from '../models/FixedPriceRepairViewModelPagedListData';
import type { FuelType } from '../models/FuelType';
import type { GetServicePriceDto } from '../models/GetServicePriceDto';
import type { GetServicePricesDto } from '../models/GetServicePricesDto';
import type { GetServicePricesDtoPagedListData } from '../models/GetServicePricesDtoPagedListData';
import type { LabourRateInput } from '../models/LabourRateInput';
import type { LabourRatesDto } from '../models/LabourRatesDto';
import type { LookupFixedPriceDto } from '../models/LookupFixedPriceDto';
import type { ManufacturerDto } from '../models/ManufacturerDto';
import type { ModelAndPriceDto } from '../models/ModelAndPriceDto';
import type { ModelAndPriceGroupedDto } from '../models/ModelAndPriceGroupedDto';
import type { ModelPricePartDto } from '../models/ModelPricePartDto';
import type { MotOptionPriceDtoPagedListData } from '../models/MotOptionPriceDtoPagedListData';
import type { PartPriceDto } from '../models/PartPriceDto';
import type { PartsAvailabilityDTOPagedListData } from '../models/PartsAvailabilityDTOPagedListData';
import type { PartServiceDto } from '../models/PartServiceDto';
import type { ServicePartServiceBulkInput } from '../models/ServicePartServiceBulkInput';
import type { ServicePartServiceInput } from '../models/ServicePartServiceInput';
import type { ServicePlanClassType } from '../models/ServicePlanClassType';
import type { ServicePlanOnsBranchDtoInput } from '../models/ServicePlanOnsBranchDtoInput';
import type { ServicePlanOnsDtoInput } from '../models/ServicePlanOnsDtoInput';
import type { ServicePlanOnsDtoPagedListData } from '../models/ServicePlanOnsDtoPagedListData';
import type { ServicePlanPricePartDto } from '../models/ServicePlanPricePartDto';
import type { ServicePlanPricePartInput } from '../models/ServicePlanPricePartInput';
import type { ServicePriceBranchesSaveModel } from '../models/ServicePriceBranchesSaveModel';
import type { ServicePriceDto } from '../models/ServicePriceDto';
import type { ServicePriceGroupDto } from '../models/ServicePriceGroupDto';
import type { ServicePriceManufactureInput } from '../models/ServicePriceManufactureInput';
import type { ServicePriceModelDto } from '../models/ServicePriceModelDto';
import type { ServicePriceModelInput } from '../models/ServicePriceModelInput';
import type { ServicePricePartsCalcDto } from '../models/ServicePricePartsCalcDto';
import type { ServicePriceSaveModel } from '../models/ServicePriceSaveModel';
import type { SortTypeEnum } from '../models/SortTypeEnum';
import type { UpdateModelPricePartDto } from '../models/UpdateModelPricePartDto';
import type { UpdateMotOptionBranchInput } from '../models/UpdateMotOptionBranchInput';
import type { UpdateMotOptionInput } from '../models/UpdateMotOptionInput';
import type { UpSellOptionsDataBranchInput } from '../models/UpSellOptionsDataBranchInput';
import type { UpSellOptionsDataDtoPagedListData } from '../models/UpSellOptionsDataDtoPagedListData';
import type { UpSellOptionsDataInput } from '../models/UpSellOptionsDataInput';
import type { VarClassEnum } from '../models/VarClassEnum';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ServicePriceService {

  /**
   * @param page 
   * @param pageSize 
   * @param branchId 
   * @param name 
   * @param isOptionsForClient 
   * @param isActiveOnly 
   * @returns AdditionalWorkDto Success
   * @throws ApiError
   */
  public static getServicePriceAdditionalWork(
page?: number,
pageSize?: number,
branchId?: number,
name?: string,
isOptionsForClient?: boolean,
isActiveOnly?: boolean,
): CancelablePromise<Array<AdditionalWorkDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/additional-work',
      query: {
        'page': page,
        'pageSize': pageSize,
        'branchId': branchId,
        'name': name,
        'isOptionsForClient': isOptionsForClient,
        'isActiveOnly': isActiveOnly,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putServicePriceAdditionalWork(
requestBody?: Array<ServicePriceSaveModel>,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-price/additional-work',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postServicePriceAdditionalWork(
requestBody?: ServicePriceSaveModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-price/additional-work',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putServicePriceAdditionalWorkBranches(
requestBody?: Array<ServicePriceBranchesSaveModel>,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-price/additional-work/branches',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postServicePriceAdditionalWorkBranches(
requestBody?: ServicePriceBranchesSaveModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-price/additional-work/branches',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteServicePriceAdditionalWork(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-price/additional-work/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param name 
   * @param branchId 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns MotOptionPriceDtoPagedListData Success
   * @throws ApiError
   */
  public static getServicePriceMotOptions(
name?: string,
branchId?: number,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<MotOptionPriceDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/mot-options',
      query: {
        'Name': name,
        'BranchId': branchId,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param userId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postServicePriceMotOptions(
userId: number,
requestBody?: CreateMotOptionInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-price/mot-options',
      query: {
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param userId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putServicePriceMotOptions(
userId: number,
requestBody?: Array<UpdateMotOptionInput>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-price/mot-options',
      query: {
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param userId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postServicePriceMotOptionsBranches(
userId: number,
requestBody?: CreateMotOptionBranchInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-price/mot-options/branches',
      query: {
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param userId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putServicePriceMotOptionsBranches(
userId: number,
requestBody?: Array<UpdateMotOptionBranchInput>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-price/mot-options/branches',
      query: {
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param userId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteServicePriceMotOptions(
id: number,
userId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-price/mot-options/{id}',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postServicePriceAddModelPricePart(
requestBody?: CreateModelPricePartDto,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-price/add-model-price-part',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putServicePriceUpdateModelPricePart(
requestBody?: UpdateModelPricePartDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-price/update-model-price-part',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteServicePriceDeleteModelPricePart(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-price/delete-model-price-part/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns ModelPricePartDto Success
   * @throws ApiError
   */
  public static getServicePriceGetByModelAndPricesId(
id: number,
): CancelablePromise<Array<ModelPricePartDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/get-by-model-and-prices-id/{id}',
      path: {
        'id': id,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postServicePriceCreateModelAndPrice(
requestBody?: ModelAndPriceDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-price/create-model-and-price',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param branchId 
   * @returns ModelAndPriceGroupedDto Success
   * @throws ApiError
   */
  public static getServicePriceGetModelsAndPricesByFixedPriceRepairId(
id: number,
branchId?: number,
): CancelablePromise<Array<ModelAndPriceGroupedDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/get-models-and-prices-by-fixed-price-repair-id/{id}',
      path: {
        'id': id,
      },
      query: {
        'branchId': branchId,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putServicePriceUpdateModelAndPrice(
id: number,
requestBody?: ModelAndPriceDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-price/update-model-and-price/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteServicePriceDeleteModelAndPrice(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-price/delete-model-and-price/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns FixedPriceRepairDto Success
   * @throws ApiError
   */
  public static getServicePriceGetFixedPriceRepairById(
id: number,
): CancelablePromise<FixedPriceRepairDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/get-fixed-price-repair-by-id/{id}',
      path: {
        'id': id,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postServicePriceCreateFixedPriceRepair(
requestBody?: FixedPriceRepairDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-price/create-fixed-price-repair',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putServicePriceUpdateFixedPriceRepair(
requestBody?: FixedPriceRepairDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-price/update-fixed-price-repair',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static getServicePriceGetDrivingAxles(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/get-driving-axles',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteServicePriceDeleteFixedPriceRepair(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-price/delete-fixed-price-repair/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param modelName 
   * @param fuelType
 *
 * 0 = Undefined
 *
 * 1 = Star2 (2-Star)
 *
 * 2 = BiFuelGas (Bi-fuel Gas)
 *
 * 3 = BiFuelPetrol (Bi-fuel Petrol)
 *
 * 4 = Diesel
 *
 * 5 = ElectricOnly (Electric only)
 *
 * 6 = Hybrid
 *
 * 7 = Lpg
 *
 * 8 = Mixed
 *
 * 9 = Other
 *
 * 10 = Petrol
 *
 * 11 = Unleaded
   * @param registrationDate 
   * @param carType
 *
 * 0 = NotChosen
 *
 * 1 = Car
 *
 * 2 = Lcv
   * @param manufacturer 
   * @param branchId 
   * @returns LookupFixedPriceDto Success
   * @throws ApiError
   */
  public static getServicePriceLookUpFixedPrices(
modelName: string,
fuelType: FuelType,
registrationDate: string,
carType: VarClassEnum,
manufacturer: number,
branchId?: number,
): CancelablePromise<Array<LookupFixedPriceDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/look-up-fixed-prices',
      query: {
        'ModelName': modelName,
        'FuelType': fuelType,
        'RegistrationDate': registrationDate,
        'CarType': carType,
        'Manufacturer': manufacturer,
        'BranchId': branchId,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param pakedPartNumber 
   * @returns PartPriceDto Success
   * @throws ApiError
   */
  public static getServicePriceGetLookupPartsPrice(
pakedPartNumber?: string,
): CancelablePromise<PartPriceDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/get-lookup-parts-price',
      query: {
        'PakedPartNumber': pakedPartNumber,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param manufacturerId 
   * @returns ServicePriceModelDto Success
   * @throws ApiError
   */
  public static getServicePriceGetModelByManufacturer(
manufacturerId?: number,
): CancelablePromise<Array<ServicePriceModelDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/get-model-by-manufacturer',
      query: {
        'manufacturerId': manufacturerId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns ManufacturerDto Success
   * @throws ApiError
   */
  public static getServicePriceGetManufacturers(): CancelablePromise<Array<ManufacturerDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/get-manufacturers',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param vehicleType
 *
 * 0 = NotChosen
 *
 * 1 = Car
 *
 * 2 = Lcv
   * @param model 
   * @param fuelType
 *
 * 0 = Undefined
 *
 * 1 = Star2 (2-Star)
 *
 * 2 = BiFuelGas (Bi-fuel Gas)
 *
 * 3 = BiFuelPetrol (Bi-fuel Petrol)
 *
 * 4 = Diesel
 *
 * 5 = ElectricOnly (Electric only)
 *
 * 6 = Hybrid
 *
 * 7 = Lpg
 *
 * 8 = Mixed
 *
 * 9 = Other
 *
 * 10 = Petrol
 *
 * 11 = Unleaded
   * @param yearFrom 
   * @param yearTo 
   * @param repairName 
   * @param branchId 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns FixedPriceRepairViewModelPagedListData Success
   * @throws ApiError
   */
  public static postServicePriceGetFixedPriceRepairList(
vehicleType?: VarClassEnum,
model?: string,
fuelType?: FuelType,
yearFrom?: number,
yearTo?: number,
repairName?: string,
branchId?: number,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<FixedPriceRepairViewModelPagedListData> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-price/get-fixed-price-repair-list',
      query: {
        'VehicleType': vehicleType,
        'Model': model,
        'FuelType': fuelType,
        'YearFrom': yearFrom,
        'YearTo': yearTo,
        'RepairName': repairName,
        'BranchId': branchId,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns string Success
   * @throws ApiError
   */
  public static getServicePriceGetFixedPriceRepairNamesList(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/get-fixed-price-repair-names-list',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns string Success
   * @throws ApiError
   */
  public static getServicePriceGetFixedPriceRepairModelList(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/get-fixed-price-repair-model-list',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Bulk updates calculation for parts and models total fields.
   * @param requestBody List of fixed repair IDs to update
   * @returns any Success
   * @throws ApiError
   */
  public static postServicePriceBulkUpdatePartPrices(
requestBody?: Array<number>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-price/bulk-update-part-prices',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param partNames 
   * @param manufacturer 
   * @param model 
   * @param fuelType
 *
 * 0 = Undefined
 *
 * 1 = Star2 (2-Star)
 *
 * 2 = BiFuelGas (Bi-fuel Gas)
 *
 * 3 = BiFuelPetrol (Bi-fuel Petrol)
 *
 * 4 = Diesel
 *
 * 5 = ElectricOnly (Electric only)
 *
 * 6 = Hybrid
 *
 * 7 = Lpg
 *
 * 8 = Mixed
 *
 * 9 = Other
 *
 * 10 = Petrol
 *
 * 11 = Unleaded
   * @param yearFrom 
   * @param yearTo 
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns PartsAvailabilityDTOPagedListData Success
   * @throws ApiError
   */
  public static getServicePriceGetPartsAvailability(
partNames?: Array<string>,
manufacturer?: number,
model?: string,
fuelType?: FuelType,
yearFrom?: number,
yearTo?: number,
sort?: string,
order?: SortTypeEnum,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<PartsAvailabilityDTOPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/get-parts-availability',
      query: {
        'PartNames': partNames,
        'Manufacturer': manufacturer,
        'Model': model,
        'FuelType': fuelType,
        'YearFrom': yearFrom,
        'YearTo': yearTo,
        'Sort': sort,
        'Order': order,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static getServicePriceUpdatePartsAvailability(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/update-parts-availability',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns string Success
   * @throws ApiError
   */
  public static getServicePriceGetPartsNames(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/get-parts-names',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param page 
   * @param pageSize 
   * @param branchId 
   * @param name 
   * @returns ServicePlanOnsDtoPagedListData Success
   * @throws ApiError
   */
  public static getPlanAddOns(
page?: number,
pageSize?: number,
branchId?: number,
name?: string,
): CancelablePromise<ServicePlanOnsDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/plan-add-ons',
      query: {
        'page': page,
        'pageSize': pageSize,
        'branchId': branchId,
        'name': name,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postPlanAddOns(
requestBody?: ServicePlanOnsDtoInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/plan-add-ons',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putPlanAddOns(
id: number,
requestBody?: ServicePlanOnsDtoInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/plan-add-ons/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deletePlanAddOns(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/plan-add-ons/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putPlanAddOnsBranches(
id: number,
requestBody?: ServicePlanOnsBranchDtoInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/plan-add-ons/{id}/branches',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postPlanAddOnsBranches(
requestBody?: ServicePlanOnsBranchDtoInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/plan-add-ons/branches',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param vehicleType
 *
 * 0 = NotChosen
 *
 * 1 = Car
 *
 * 2 = Lcv
   * @param manufactureId 
   * @param modelId 
   * @param model 
   * @param fuelType
 *
 * 0 = Undefined
 *
 * 1 = Star2 (2-Star)
 *
 * 2 = BiFuelGas (Bi-fuel Gas)
 *
 * 3 = BiFuelPetrol (Bi-fuel Petrol)
 *
 * 4 = Diesel
 *
 * 5 = ElectricOnly (Electric only)
 *
 * 6 = Hybrid
 *
 * 7 = Lpg
 *
 * 8 = Mixed
 *
 * 9 = Other
 *
 * 10 = Petrol
 *
 * 11 = Unleaded
   * @param from 
   * @param to 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns GetServicePricesDtoPagedListData Success
   * @throws ApiError
   */
  public static getServicePrices(
vehicleType?: VarClassEnum,
manufactureId?: number,
modelId?: number,
model?: string,
fuelType?: FuelType,
from?: string,
to?: string,
branch?: BranchType,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<GetServicePricesDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-prices',
      query: {
        'VehicleType': vehicleType,
        'ManufactureId': manufactureId,
        'ModelId': modelId,
        'Model': model,
        'FuelType': fuelType,
        'From': from,
        'To': to,
        'Branch': branch,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postServicePrices(
requestBody?: CreateServicePriceInput,
): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-prices',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param ids 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static putServicePrices(
ids: Array<number>,
requestBody?: CreateServicePriceInput,
): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-prices',
      query: {
        'ids': ids,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param ids 
   * @returns GetServicePricesDto Success
   * @throws ApiError
   */
  public static getServicePricesByIds(
ids: Array<number>,
): CancelablePromise<GetServicePricesDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-prices/by-ids',
      query: {
        'ids': ids,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param modelName 
   * @param fuelType
 *
 * 0 = Undefined
 *
 * 1 = Star2 (2-Star)
 *
 * 2 = BiFuelGas (Bi-fuel Gas)
 *
 * 3 = BiFuelPetrol (Bi-fuel Petrol)
 *
 * 4 = Diesel
 *
 * 5 = ElectricOnly (Electric only)
 *
 * 6 = Hybrid
 *
 * 7 = Lpg
 *
 * 8 = Mixed
 *
 * 9 = Other
 *
 * 10 = Petrol
 *
 * 11 = Unleaded
   * @param registrationDate 
   * @param carType
 *
 * 2 = Car (CAR)
 *
 * 5 = Van (VAN)
   * @param manufacturer 
   * @param branchId 
   * @param classType
 *
 * 1 = ManufacturerMenu
 *
 * 2 = EurorepairParts
 *
 * 3 = Flexible
 *
 * -1 = All
   * @param nextServiceDate 
   * @returns ServicePriceDto Created
   * @throws ApiError
   */
  public static getServicePricesLookUp(
modelName?: string,
fuelType?: FuelType,
registrationDate?: string,
carType?: CarClass,
manufacturer?: number,
branchId?: number,
classType?: ServicePlanClassType,
nextServiceDate?: string,
): CancelablePromise<ServicePriceDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-prices/look-up',
      query: {
        'modelName': modelName,
        'fuelType': fuelType,
        'registrationDate': registrationDate,
        'carType': carType,
        'manufacturer': manufacturer,
        'branchId': branchId,
        'classType': classType,
        'nextServiceDate': nextServiceDate,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param ids 
   * @returns ServicePricePartsCalcDto Success
   * @throws ApiError
   */
  public static getServicePricesCalculateParts(
ids: Array<number>,
): CancelablePromise<ServicePricePartsCalcDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-prices/calculate-parts',
      query: {
        'ids': ids,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param ids 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteServicePricesRemove(
ids: Array<number>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-prices/remove',
      query: {
        'ids': ids,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postServicePricesManufacturers(
requestBody?: ServicePriceManufactureInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-prices/manufacturers',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteServicePricesManufacturers(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-prices/manufacturers/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postServicePricesModels(
requestBody?: ServicePriceModelInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-prices/models',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteServicePricesModels(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-prices/models/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param modelId 
   * @param fuelType
 *
 * 0 = Undefined
 *
 * 1 = Star2 (2-Star)
 *
 * 2 = BiFuelGas (Bi-fuel Gas)
 *
 * 3 = BiFuelPetrol (Bi-fuel Petrol)
 *
 * 4 = Diesel
 *
 * 5 = ElectricOnly (Electric only)
 *
 * 6 = Hybrid
 *
 * 7 = Lpg
 *
 * 8 = Mixed
 *
 * 9 = Other
 *
 * 10 = Petrol
 *
 * 11 = Unleaded
   * @param varClass
 *
 * 0 = NotChosen
 *
 * 1 = Car
 *
 * 2 = Lcv
   * @param modelFrom 
   * @param modelTo 
   * @returns ServicePlanPricePartDto Success
   * @throws ApiError
   */
  public static getServicePricesParts(
modelId: number,
fuelType: FuelType,
varClass: VarClassEnum,
modelFrom?: string,
modelTo?: string,
): CancelablePromise<Array<ServicePlanPricePartDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-prices/parts',
      query: {
        'modelId': modelId,
        'fuelType': fuelType,
        'modelFrom': modelFrom,
        'modelTo': modelTo,
        'varClass': varClass,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postServicePricesParts(
requestBody?: ServicePlanPricePartInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-prices/parts',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postServicePricesPartsBulk(
requestBody?: Array<ServicePlanPricePartInput>,
): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-prices/parts/bulk',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param ids 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteServicePricesPartsBulk(
ids?: Array<number>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-prices/parts/bulk',
      query: {
        'ids': ids,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteServicePricesParts(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-prices/parts/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putServicePricesParts(
id: number,
requestBody?: ServicePlanPricePartInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-prices/parts/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param groupId 
   * @returns PartServiceDto Success
   * @throws ApiError
   */
  public static getServicePricesServiceParts(
groupId?: number,
): CancelablePromise<Array<PartServiceDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-prices/service-parts',
      query: {
        'groupId': groupId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param groupId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putServicePricesServiceParts(
id: number,
groupId?: number,
requestBody?: ServicePartServiceInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-prices/service-parts/{id}',
      path: {
        'id': id,
      },
      query: {
        'groupId': groupId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putServicePricesServicePartsBulk(
requestBody?: Array<ServicePartServiceBulkInput>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-prices/service-parts/bulk',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branchId 
   * @param manufactureId 
   * @returns LabourRatesDto Success
   * @throws ApiError
   */
  public static getServicePricesLabourRates(
branchId?: number,
manufactureId?: number,
): CancelablePromise<Array<LabourRatesDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-prices/labour-rates',
      query: {
        'branchId': branchId,
        'manufactureId': manufactureId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postServicePricesLabourRates(
requestBody?: LabourRateInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-prices/labour-rates',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param groupId 
   * @returns GetServicePricesDto Success
   * @throws ApiError
   */
  public static getGroupsServicePrices(
groupId: number,
): CancelablePromise<GetServicePricesDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/groups/{groupId}/service-prices',
      path: {
        'groupId': groupId,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param groupId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putGroupsServicePrices(
groupId: number,
requestBody?: CreateServicePriceInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/groups/{groupId}/service-prices',
      path: {
        'groupId': groupId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param groupId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static patchGroupsServicePrices(
groupId: number,
requestBody?: GetServicePriceDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/groups/{groupId}/service-prices',
      path: {
        'groupId': groupId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param groupId 
   * @param number 
   * @param priceClass
 *
 * 1 = ManufacturerMenu
 *
 * 2 = EurorepairParts
 *
 * 3 = Flexible
 *
 * -1 = All
   * @returns any Success
   * @throws ApiError
   */
  public static deleteGroupsServicePrices(
groupId: number,
number?: number,
priceClass?: ServicePlanClassType,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/groups/{groupId}/service-prices',
      path: {
        'groupId': groupId,
      },
      query: {
        'number': number,
        'priceClass': priceClass,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param groupId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteGroups(
groupId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/groups/{groupId}',
      path: {
        'groupId': groupId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param groupId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putGroups(
groupId: number,
requestBody?: ServicePriceGroupDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/groups/{groupId}',
      path: {
        'groupId': groupId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postGroups(
requestBody?: CreateServicePriceGroupInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/groups',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postGroupsServicePrices(
requestBody?: CreateServicePriceInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/groups/service-prices',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param groupId 
   * @param number 
   * @param priceClass
 *
 * 1 = ManufacturerMenu
 *
 * 2 = EurorepairParts
 *
 * 3 = Flexible
 *
 * -1 = All
   * @param labour 
   * @returns number Success
   * @throws ApiError
   */
  public static getGroupsServicePricesCalculateParts(
groupId: number,
number?: number,
priceClass?: ServicePlanClassType,
labour?: number,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/groups/{groupId}/service-prices/calculate-parts',
      path: {
        'groupId': groupId,
      },
      query: {
        'number': number,
        'priceClass': priceClass,
        'labour': labour,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static getGroupsCalculateAllPricesInGroup(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/groups/{id}/calculate-all-prices-in-group',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putGroupsUpdatePricesByBranches(
id: number,
requestBody?: Array<number>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/groups/{id}/update-prices-by-branches',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branchId 
   * @param isActiveOnly 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns UpSellOptionsDataDtoPagedListData Success
   * @throws ApiError
   */
  public static getServicePriceUpSellOptions(
branchId?: number,
isActiveOnly?: boolean,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<UpSellOptionsDataDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-price/up-sell-options',
      query: {
        'BranchId': branchId,
        'IsActiveOnly': isActiveOnly,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postServicePriceUpSellOptions(
requestBody?: UpSellOptionsDataInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-price/up-sell-options',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postServicePriceUpSellOptionsBranches(
requestBody?: UpSellOptionsDataBranchInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-price/up-sell-options/branches',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putServicePriceUpSellOptions(
id: number,
requestBody?: UpSellOptionsDataInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-price/up-sell-options/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteServicePriceUpSellOptions(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-price/up-sell-options/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putServicePriceUpSellOptionsBranches(
id: number,
requestBody?: UpSellOptionsDataBranchInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-price/up-sell-options/{id}/branches',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branchId 
   * @returns EventServicesDto Success
   * @throws ApiError
   */
  public static getServicePricesEventServices(
branchId?: number,
): CancelablePromise<Array<EventServicesDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-prices/event-services',
      query: {
        'branchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postServicePricesEventServices(
requestBody?: EventServicesInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-prices/event-services',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param years 
   * @param branchId 
   * @returns EventServicesDto Success
   * @throws ApiError
   */
  public static getServicePricesEventServicesYears(
years?: number,
branchId?: number,
): CancelablePromise<Array<EventServicesDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-prices/event-services-years',
      query: {
        'years': years,
        'branchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteServicePricesEventServices(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-prices/event-services/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putServicePricesEventServices(
id: number,
requestBody?: EventServicesInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-prices/event-services/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
